export default __webpack_public_path__ + "static/media/scotiabank-logo.24db431c.png";